import React, { useState, useEffect } from 'react'
import Tooltip from '../GeneralTextInput/Tooltip'
import styled from 'styled-components'
import { Asterisk, Icon } from '../GeneralTextInput/styles'
import { ButtonRadio } from './ButttonRadio'

interface RadioProps<T> {
    title: string
    value: T
    options: T[]
    onChange: (scheduleType: T) => void
    toLabel: (objectType: T) => string
    isSelected: (objectType: T) => boolean
    required?: boolean
    tooltip?: React.ReactElement | string
    tooltipClassName?: string
}

export function RadioGroup<T>({
    title,
    required,
    tooltip,
    tooltipClassName,
    options,
    onChange,
    toLabel,
    isSelected
}: RadioProps<T>) {
    return (
        <RadioContainer>
            <div className="radio-container-title">
                <label className='radion-title-label'>{title}</label>
                {tooltip && (
                    <div className='div-radio-label-tooltip'>
                        <Tooltip
                            className={`radio-label-tooltip ${tooltipClassName}`}
                            text={tooltip}
                        />
                        <Icon className={'far fa-info-circle'} />
                    </div>
                    
                )}
                {required && <Asterisk>*</Asterisk>}
            </div>
            <FormContainer>
                {options.map((option, index) => {
                    const label = toLabel(option)
                    return (
                        <ButtonRadio
                            id={`option-radio-${label}-${index}`}
                            label={label}
                            onChange={onChange}
                            selected={isSelected(option)}
                            value={option}
                            description=""
                            icon=""
                        />
                    )
                })}
            </FormContainer>
        </RadioContainer>
    )
}

const RadioContainer = styled.div`
    .radio-container-title {
        padding-bottom: 8px;
        display: flex;
        label {
            font-family: ${({ theme }) => theme['font-semibold']};
            font-size: 13px;
            line-height: 16px;
            font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
            color: #364159;
        }
        .div-radio-label-tooltip {
            display: flex;
            justify-content: center;
            position: relative;
            overflow: visible;
            cursor: pointer;
            &:hover {
                .radio-label-tooltip {
                    color: ${({theme}) => theme['gray-800']};
                    min-width: 380px;
                    display: flex;
                    visibility: visible;
                    .info-block {
                        padding: 8px 16px;
                    }
                }
            }
        }
    }
`

const FormContainer = styled.form`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 8px;

    .buttonContainer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid var(--gray-500);
        border-radius: 3px;
        min-height: 38px;
        max-height: 48px;
        
        cursor: pointer;
        * {
            cursor: pointer;
        }

        .mainLabelDiv {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            /* border: 1px solid red; */

            .mainLabel {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .iconDiv {
                width: 16px;
                /* padding: 8px; */

                i {
                    padding: 2px 4px;
                    text-align: center;
                    font-size: 16px;
                    color: var(--gray-500);
                }
            }

            .textDiv {
                padding-left: 8px;
                width: 100%;
                .labelDiv {
                    margin-bottom: -4px;
                }

                .descriptionDiv {
                    font-family: SourceSansPro-Regular, Arial, Helvetica Neue, Helvetica, sans-serif;
                    width: 80%;
                    font-weight: 400;
                    font-size: 11px;
                    padding: 0;
                    margin-top: -4px;

                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .inputContainer {
            display: flex;
            align-items: center;
            justify-content: center;
            /* border: 1px solid green; */

            margin-right: 8px;
            max-width: 16px;
            min-width: 16px;
            input[type='radio'] {
                -ms-transform: scale(1.3);
                -webkit-transform: scale(1.3);
                transform: scale(1.3);
                :after {
                    top: 3px;
                    left: 3px;
                }
            }

            input[type='radio']::after {
                left: 4px;
            }
        }

        &:focus {
            outline: 1px solid var(--blue-500);
        }
        &:focus-within {
            outline: 1px solid var(--blue-500);
        }
    }

    .Checked {
        background: var(--gray-0); // Change the background color of the div
        
        &:focus {
            outline: 1px solid var(--blue-500);
            /* background: var(--gray-100) */
        }
        &:focus-within {
            outline: 1px solid var(--blue-500);
            /* background: var(--gray-100) */
        }
    }
`

// <div className={`buttonContainer ${op?.label == previosChecked ? 'Checked' : ''}`}>
// <div className="mainLabelDiv">
//     <label className="mainLabel">
//         {op.icon && (
//             <div className="iconDiv">
//                 <i className={op.icon} />
//             </div>
//         )}
//         <div className="textDiv">
//             <div className="labelDiv">{op.label}</div>
//             {op.description && <div className="descriptionDiv">{op.description}</div>}
//         </div>
//     </label>
// </div>
// <div className="inputContainer">
//     <input
//         key={op.label}
//         type="radio"
//         name="radioGroup"
//         value={op.label}
//         checked={Checked}
//         onChange={handleRadioButtonChange}
//     />
// </div>
// </div>
